var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasonry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Masonry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 10.2692L6.46875 4.74038C6.46875 4.67663 6.42595 4.61549 6.34976 4.57041C6.27358 4.52533 6.17024 4.5 6.0625 4.5H2.8125C2.59701 4.5 2.39035 4.55065 2.23798 4.64081C2.0856 4.73098 2 4.85326 2 4.98077L2 10.0288C2 10.0926 2.0428 10.1537 2.11899 10.1988C2.19517 10.2439 2.29851 10.2692 2.40625 10.2692H6.46875Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 7.38461V4.74038C12.5625 4.67663 12.5197 4.61549 12.4435 4.57041C12.3673 4.52533 12.264 4.5 12.1562 4.5H8.5C8.39226 4.5 8.28892 4.52533 8.21274 4.57041C8.13655 4.61549 8.09375 4.67663 8.09375 4.74038V7.38461H12.5625Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 8.34615V13.1538H12.5625V8.34615H8.09375Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 14.1154V16.7596C8.09375 16.8234 8.13655 16.8845 8.21274 16.9296C8.28892 16.9747 8.39226 17 8.5 17H12.1562C12.264 17 12.3673 16.9747 12.4435 16.9296C12.5197 16.8845 12.5625 16.8234 12.5625 16.7596V14.1154H8.09375Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 10.2692H17.8437C17.9515 10.2692 18.0548 10.2439 18.131 10.1988C18.2072 10.1537 18.25 10.0926 18.25 10.0288V4.98077C18.25 4.85326 18.1644 4.73098 18.012 4.64081C17.8597 4.55065 17.653 4.5 17.4375 4.5L14.5938 4.5C14.486 4.5 14.3827 4.52533 14.3065 4.57041C14.2303 4.61549 14.1875 4.67663 14.1875 4.74038V10.2692Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 11.2308H2.40625C2.29851 11.2308 2.19517 11.2561 2.11899 11.3012C2.0428 11.3463 2 11.4074 2 11.4712L2 16.5192C2 16.6467 2.0856 16.769 2.23798 16.8592C2.39035 16.9493 2.59701 17 2.8125 17H6.0625C6.17024 17 6.27358 16.9747 6.34976 16.9296C6.42595 16.8845 6.46875 16.8234 6.46875 16.7596V11.2308Z",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 11.2308V16.7596C14.1875 16.8234 14.2303 16.8845 14.3065 16.9296C14.3827 16.9747 14.486 17 14.5938 17H17.4375C17.653 17 17.8597 16.9493 18.012 16.8592C18.1644 16.769 18.25 16.6467 18.25 16.5192V11.4712C18.25 11.4074 18.2072 11.3463 18.131 11.3012C18.0548 11.2561 17.9515 11.2308 17.8437 11.2308H14.1875Z",
    fill: "#CDCED6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasonry);
export default __webpack_public_path__ + "static/media/masonry.b797ec527ba1f4c4a8b87f282b22817c.svg";
export { ForwardRef as ReactComponent };